(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@innovyze/lib-am-common/Reducers"), require("@reduxjs/toolkit"), require("redux"));
	else if(typeof define === 'function' && define.amd)
		define(["@innovyze/lib-am-common/Reducers", "@Reduxjs/Toolkit", "Redux"], factory);
	else if(typeof exports === 'object')
		exports["app-MODULE-NAME"] = factory(require("@innovyze/lib-am-common/Reducers"), require("@reduxjs/toolkit"), require("redux"));
	else
		root["app-MODULE-NAME"] = factory(root["@innovyze/lib-am-common/Reducers"], root["@Reduxjs/Toolkit"], root["Redux"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Reducers__, __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__, __WEBPACK_EXTERNAL_MODULE_redux__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./actions/deteriorationModels.actions.ts":
/*!************************************************!*\
  !*** ./actions/deteriorationModels.actions.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.listDeteriorationModelGroupsResultsRejected = exports.listDeteriorationModelGroupsResultsResolved = exports.listDeteriorationModelGroupsResultsAction = exports.listDeteriorationModelAssetsResultsRejected = exports.listDeteriorationModelAssetsResultsResolved = exports.listDeteriorationModelAssetsResultsAction = exports.getIndustryStandardCurvesResolved = exports.getIndustryStandardCurvesAction = exports.listDeteriorationModelCurveConfigsRejected = exports.listDeteriorationModelCurveConfigsResolved = exports.listDeteriorationModelCurveConfigsAction = exports.getDeteriorationModelStatusRejected = exports.getDeteriorationModelStatusResolved = exports.getDeteriorationModelStatus = exports.getDeteriorationModelRejected = exports.getDeteriorationModelResolved = exports.getDeteriorationModel = exports.resetDeteriorationModels = exports.listDeteriorationModelsRejected = exports.listDeteriorationModelsResolved = exports.listDeteriorationModels = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
exports.listDeteriorationModels = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/list'));
exports.listDeteriorationModelsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/listResolved'));
exports.listDeteriorationModelsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/listRejected'));
exports.resetDeteriorationModels = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/reset'));
exports.getDeteriorationModel = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/get'));
exports.getDeteriorationModelResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/getResolved'));
exports.getDeteriorationModelRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/getRejected'));
exports.getDeteriorationModelStatus = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/getStatus'));
exports.getDeteriorationModelStatusResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/getStatusResolved'));
exports.getDeteriorationModelStatusRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/getStatusRejected'));
exports.listDeteriorationModelCurveConfigsAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/curveConfigs/list'));
exports.listDeteriorationModelCurveConfigsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/curveConfigs/listResolved'));
exports.listDeteriorationModelCurveConfigsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/curveConfigs/listRejected'));
exports.getIndustryStandardCurvesAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/industryStandardCurves/get'));
exports.getIndustryStandardCurvesResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/industryStandardCurves/getResolved'));
exports.listDeteriorationModelAssetsResultsAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/assetsResults/list'));
exports.listDeteriorationModelAssetsResultsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/assetsResults/listResolved'));
exports.listDeteriorationModelAssetsResultsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/assetsResults/listRejected'));
exports.listDeteriorationModelGroupsResultsAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/groupsResults/list'));
exports.listDeteriorationModelGroupsResultsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/groupsResults/listResolved'));
exports.listDeteriorationModelGroupsResultsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/groupsResults/listRejected'));


/***/ }),

/***/ "./actions/failureDefinition.actions.ts":
/*!**********************************************!*\
  !*** ./actions/failureDefinition.actions.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getFailureDefinitionRunResultsRejected = exports.getFailureDefinitionRunResultsResolved = exports.getFailureDefinitionRunResults = exports.deleteFailureDefinitionRejected = exports.deleteFailureDefinitionResolved = exports.deleteFailureDefinition = exports.getFailureDefinitionRejected = exports.getFailureDefinitionResolved = exports.getFailureDefinitionAction = exports.listAllFailureDefinitionsRejected = exports.listAllFailureDefinitionsResolved = exports.listAllFailureDefinitions = exports.runFailureDefinitionRejected = exports.runFailureDefinitionResolved = exports.runFailureDefinition = exports.clearFailureDefinitionCreationState = exports.createFailureDefinitionRejected = exports.createFailureDefinitionResolved = exports.createFailureDefinition = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
exports.createFailureDefinition = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/create'));
exports.createFailureDefinitionResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/createResolved'));
exports.createFailureDefinitionRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/createRejected'));
exports.clearFailureDefinitionCreationState = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/clearCreationState'));
exports.runFailureDefinition = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/run'));
exports.runFailureDefinitionResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/runResolved'));
exports.runFailureDefinitionRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/runRejected'));
exports.listAllFailureDefinitions = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/listAll'));
exports.listAllFailureDefinitionsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/listAllResolved'));
exports.listAllFailureDefinitionsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/listAllRejected'));
exports.getFailureDefinitionAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/get'));
exports.getFailureDefinitionResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/getResolved'));
exports.getFailureDefinitionRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/getRejected'));
exports.deleteFailureDefinition = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/delete'));
exports.deleteFailureDefinitionResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/deleteResolved'));
exports.deleteFailureDefinitionRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/deleteRejected'));
exports.getFailureDefinitionRunResults = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/getRunResults'));
exports.getFailureDefinitionRunResultsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/getRunResultsResolved'));
exports.getFailureDefinitionRunResultsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/getRunResultsRejected'));


/***/ }),

/***/ "./actions/groupSets.actions.ts":
/*!**************************************!*\
  !*** ./actions/groupSets.actions.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getGroupSetResolved = exports.getGroupSetAction = exports.listGroupSetsResolved = exports.listGroupSets = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.listGroupSets = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('groupSets/list'));
exports.listGroupSetsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('groupSets/list/resolved'));
exports.getGroupSetAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('groupSet/get'));
exports.getGroupSetResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('groupSets/get/resolved'));


/***/ }),

/***/ "./actions/inspections.actions.ts":
/*!****************************************!*\
  !*** ./actions/inspections.actions.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchInspectionStandardCodesRejected = exports.fetchInspectionStandardCodesResolved = exports.fetchInspectionStandardCodes = exports.fetchInspectionOverviewRejected = exports.fetchInspectionOverviewResolved = exports.fetchInspectionOverview = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.fetchInspectionOverview = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/list'));
exports.fetchInspectionOverviewResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/list/resolved'));
exports.fetchInspectionOverviewRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/list/rejected'));
exports.fetchInspectionStandardCodes = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/codes/list'));
exports.fetchInspectionStandardCodesResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/codes/list/resolved'));
exports.fetchInspectionStandardCodesRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/codes/list/rejected'));


/***/ }),

/***/ "./actions/rehab.actions.ts":
/*!**********************************!*\
  !*** ./actions/rehab.actions.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchFieldMetadataRejected = exports.fetchFieldMetadataResolved = exports.fetchFieldMetadataAction = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.fetchFieldMetadataAction = (0, toolkit_1.createAction)('rehab/fieldMetadata/fetch');
exports.fetchFieldMetadataResolved = (0, toolkit_1.createAction)('rehab/fieldMetadata/resolved');
exports.fetchFieldMetadataRejected = (0, toolkit_1.createAction)('rehab/fieldMetadata/rejected');


/***/ }),

/***/ "./actions/util.actions.ts":
/*!*********************************!*\
  !*** ./actions/util.actions.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setAssetBackLabel = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.setAssetBackLabel = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('util/setAssetBackLabel'));


/***/ }),

/***/ "./reducers/deteriorationModels.reducer.ts":
/*!*************************************************!*\
  !*** ./reducers/deteriorationModels.reducer.ts ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reducer = exports.initState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var AM_COMMON = __importStar(__webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers"));
var deteriorationModels_actions_1 = __webpack_require__(/*! @Actions/deteriorationModels.actions */ "./actions/deteriorationModels.actions.ts");
exports.initState = {
    deteriorationModelsList: AM_COMMON.paginationInitialState,
    selectedDeteriorationModel: {
        inProcess: false,
        successful: null,
        deteriorationModel: null,
    },
    deteriorationModelCurveConfigsList: {
        pagination: AM_COMMON.paginationInitialState,
        list: [],
    },
    industryStandardCurves: {
        isLoading: false,
        curves: [],
    },
    assetResults: AM_COMMON.paginationInitialState,
    groupResults: AM_COMMON.paginationInitialState,
};
exports.reducer = (0, toolkit_1.createReducer)(exports.initState, function (builder) {
    builder
        .addCase(deteriorationModels_actions_1.listDeteriorationModels, function (state) {
        state.deteriorationModelsList = AM_COMMON.updateIsLoading(AM_COMMON.paginationInitialState, true);
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelsResolved, function (state, action) {
        state.deteriorationModelsList = AM_COMMON.updateResolvedCard(state.deteriorationModelsList, action.payload);
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelsRejected, function (state, action) {
        state.deteriorationModelsList = AM_COMMON.updateRejected(state.deteriorationModelsList, action.payload);
    })
        .addCase(deteriorationModels_actions_1.getDeteriorationModel, function (state) {
        state.selectedDeteriorationModel = {
            inProcess: true,
            successful: null,
            deteriorationModel: null,
        };
    })
        .addCase(deteriorationModels_actions_1.getDeteriorationModelResolved, function (state, action) {
        state.selectedDeteriorationModel = {
            inProcess: false,
            successful: true,
            deteriorationModel: action.payload,
        };
    })
        .addCase(deteriorationModels_actions_1.getDeteriorationModelRejected, function (state) {
        state.selectedDeteriorationModel = {
            inProcess: false,
            successful: false,
            deteriorationModel: null,
        };
    })
        .addCase(deteriorationModels_actions_1.getDeteriorationModelStatusResolved, function (state, action) {
        // Only update the status, preserve existing loading states and other model data
        if (state.selectedDeteriorationModel.successful !== false &&
            state.selectedDeteriorationModel.deteriorationModel) {
            state.selectedDeteriorationModel.deteriorationModel.status = action.payload.status;
        }
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelCurveConfigsAction, function (state) {
        state.deteriorationModelCurveConfigsList = {
            pagination: AM_COMMON.updateIsLoading(AM_COMMON.paginationInitialState, true),
            list: [],
        };
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelCurveConfigsResolved, function (state, action) {
        state.deteriorationModelCurveConfigsList = {
            pagination: AM_COMMON.updateResolved(state.deteriorationModelCurveConfigsList.pagination, action.payload.response),
            list: action.payload.curveConfigs,
        };
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelCurveConfigsRejected, function (state, action) {
        state.deteriorationModelCurveConfigsList = {
            pagination: AM_COMMON.updateRejected(state.deteriorationModelCurveConfigsList.pagination, action.payload),
            list: [],
        };
    })
        .addCase(deteriorationModels_actions_1.getIndustryStandardCurvesAction, function (state) {
        state.industryStandardCurves = {
            isLoading: true,
            curves: [],
        };
    })
        .addCase(deteriorationModels_actions_1.getIndustryStandardCurvesResolved, function (state, action) {
        state.industryStandardCurves = {
            isLoading: false,
            curves: action.payload,
        };
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelAssetsResultsAction, function (state) {
        state.assetResults = AM_COMMON.updateIsLoading(state.assetResults, true);
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelAssetsResultsResolved, function (state, action) {
        state.assetResults = AM_COMMON.updateResolved(state.assetResults, action.payload);
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelAssetsResultsRejected, function (state, action) {
        state.assetResults = AM_COMMON.updateRejected(state.assetResults, action.payload);
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelGroupsResultsAction, function (state) {
        state.groupResults = AM_COMMON.updateIsLoading(state.groupResults, true);
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelGroupsResultsResolved, function (state, action) {
        state.groupResults = AM_COMMON.updateResolved(state.groupResults, action.payload);
    })
        .addCase(deteriorationModels_actions_1.listDeteriorationModelGroupsResultsRejected, function (state, action) {
        state.groupResults = AM_COMMON.updateRejected(state.groupResults, action.payload);
    });
});
exports["default"] = exports.reducer;


/***/ }),

/***/ "./reducers/failureDefinition.reducer.ts":
/*!***********************************************!*\
  !*** ./reducers/failureDefinition.reducer.ts ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.failureDefinitionReducer = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var AM_COMMON = __importStar(__webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers"));
var failureDefinition_actions_1 = __webpack_require__(/*! @Actions/failureDefinition.actions */ "./actions/failureDefinition.actions.ts");
var initialState = {
    inProcess: false,
    successful: null,
    id: null,
    run: {
        inProcess: false,
        successful: null,
    },
    allFailureDefinitionsList: {
        inProcess: false,
        successful: null,
        failureDefinitions: [],
    },
    failureDefinition: {
        inProcess: false,
        successful: null,
        failureDefinition: null,
    },
    failureDefinitionRunResults: AM_COMMON.paginationInitialState,
};
exports.failureDefinitionReducer = (0, toolkit_1.createReducer)(initialState, function (builder) {
    builder
        .addCase(failureDefinition_actions_1.createFailureDefinition, function (state) {
        state.inProcess = true;
        state.successful = null;
        state.id = null;
        state.run.inProcess = false;
        state.run.successful = null;
    })
        .addCase(failureDefinition_actions_1.createFailureDefinitionResolved, function (state, action) {
        state.inProcess = false;
        state.successful = true;
        state.id = action.payload.id;
    })
        .addCase(failureDefinition_actions_1.createFailureDefinitionRejected, function (state) {
        state.inProcess = false;
        state.successful = false;
        state.id = null;
        state.run.inProcess = false;
        state.run.successful = null;
    })
        .addCase(failureDefinition_actions_1.runFailureDefinition, function (state) {
        state.run.inProcess = true;
        state.run.successful = null;
    })
        .addCase(failureDefinition_actions_1.runFailureDefinitionResolved, function (state) {
        state.run.inProcess = false;
        state.run.successful = true;
    })
        .addCase(failureDefinition_actions_1.runFailureDefinitionRejected, function (state) {
        state.run.inProcess = false;
        state.run.successful = false;
    })
        .addCase(failureDefinition_actions_1.listAllFailureDefinitions, function (state) {
        state.allFailureDefinitionsList = {
            inProcess: true,
            successful: null,
            failureDefinitions: [],
        };
    })
        .addCase(failureDefinition_actions_1.listAllFailureDefinitionsRejected, function (state) {
        state.allFailureDefinitionsList = {
            inProcess: false,
            successful: false,
            failureDefinitions: [],
        };
    })
        .addCase(failureDefinition_actions_1.listAllFailureDefinitionsResolved, function (state, action) {
        state.allFailureDefinitionsList = {
            inProcess: false,
            successful: true,
            failureDefinitions: action.payload,
        };
    })
        .addCase(failureDefinition_actions_1.getFailureDefinitionAction, function (state) {
        state.failureDefinition = {
            inProcess: true,
            successful: null,
            failureDefinition: null,
        };
    })
        .addCase(failureDefinition_actions_1.getFailureDefinitionResolved, function (state, action) {
        state.failureDefinition = {
            inProcess: false,
            successful: true,
            failureDefinition: action.payload,
        };
    })
        .addCase(failureDefinition_actions_1.getFailureDefinitionRejected, function (state) {
        state.failureDefinition = {
            inProcess: false,
            successful: false,
            failureDefinition: null,
        };
    })
        .addCase(failureDefinition_actions_1.getFailureDefinitionRunResults, function (state) {
        state.failureDefinitionRunResults = AM_COMMON.updateIsLoading(state.failureDefinitionRunResults, true);
    })
        .addCase(failureDefinition_actions_1.getFailureDefinitionRunResultsResolved, function (state, action) {
        state.failureDefinitionRunResults = AM_COMMON.updateResolved(state.failureDefinitionRunResults, action.payload);
    })
        .addCase(failureDefinition_actions_1.getFailureDefinitionRunResultsRejected, function (state, action) {
        state.failureDefinitionRunResults = AM_COMMON.updateRejected(state.failureDefinitionRunResults, action.payload);
    })
        .addCase(failureDefinition_actions_1.clearFailureDefinitionCreationState, function (state) {
        state.inProcess = false;
        state.successful = null;
        state.id = null;
    });
});
exports["default"] = exports.failureDefinitionReducer;


/***/ }),

/***/ "./reducers/groupSets.reducer.ts":
/*!***************************************!*\
  !*** ./reducers/groupSets.reducer.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.groupSetsReducer = exports.initState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var groupSets_actions_1 = __webpack_require__(/*! @Actions/groupSets.actions */ "./actions/groupSets.actions.ts");
exports.initState = {
    isLoading: false,
    groupSetsList: [],
    groupSet: {
        isLoading: false,
        groupSet: null,
    },
};
exports.groupSetsReducer = (0, toolkit_1.createReducer)(exports.initState, function (builder) {
    builder
        .addCase(groupSets_actions_1.listGroupSets, function (state) {
        state.isLoading = true;
    })
        .addCase(groupSets_actions_1.listGroupSetsResolved, function (state, action) {
        state.groupSetsList = action.payload;
        state.isLoading = false;
    })
        .addCase(groupSets_actions_1.getGroupSetAction, function (state) {
        state.groupSet = {
            isLoading: true,
            groupSet: null,
        };
    })
        .addCase(groupSets_actions_1.getGroupSetResolved, function (state, action) {
        state.groupSet = {
            isLoading: false,
            groupSet: {
                id: action.payload._id,
                name: action.payload.name,
                systemType: action.payload.systemType,
                assetType: action.payload.assetType,
            },
        };
    });
});
exports["default"] = exports.groupSetsReducer;


/***/ }),

/***/ "./reducers/index.ts":
/*!***************************!*\
  !*** ./reducers/index.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var deteriorationModels_reducer_1 = __importDefault(__webpack_require__(/*! ./deteriorationModels.reducer */ "./reducers/deteriorationModels.reducer.ts"));
var failureDefinition_reducer_1 = __importDefault(__webpack_require__(/*! ./failureDefinition.reducer */ "./reducers/failureDefinition.reducer.ts"));
var groupSets_reducer_1 = __importDefault(__webpack_require__(/*! ./groupSets.reducer */ "./reducers/groupSets.reducer.ts"));
var inspections_reducer_1 = __importDefault(__webpack_require__(/*! ./inspections.reducer */ "./reducers/inspections.reducer.ts"));
var rehab_reducer_1 = __importDefault(__webpack_require__(/*! ./rehab.reducer */ "./reducers/rehab.reducer.ts"));
var util_reducer_1 = __importDefault(__webpack_require__(/*! ./util.reducer */ "./reducers/util.reducer.ts"));
var redux_1 = __webpack_require__(/*! redux */ "redux");
exports["default"] = (0, redux_1.combineReducers)({
    DeteriorationModelsStore: deteriorationModels_reducer_1.default,
    FailureDefinitionsStore: failureDefinition_reducer_1.default,
    GroupSetsStore: groupSets_reducer_1.default,
    InspectionTypesStore: inspections_reducer_1.default,
    RehabStore: rehab_reducer_1.default,
    util: util_reducer_1.default,
});


/***/ }),

/***/ "./reducers/inspections.reducer.ts":
/*!*****************************************!*\
  !*** ./reducers/inspections.reducer.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initialState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var inspections_actions_1 = __webpack_require__(/*! @Actions/inspections.actions */ "./actions/inspections.actions.ts");
exports.initialState = {
    isLoading: false,
    inspectionTypeList: [],
    codesByStandard: {},
};
var inspectionTypesReducer = (0, toolkit_1.createReducer)(exports.initialState, function (builder) {
    builder
        .addCase(inspections_actions_1.fetchInspectionOverview, function (state) {
        state.isLoading = true;
    })
        .addCase(inspections_actions_1.fetchInspectionOverviewResolved, function (state, action) {
        state.isLoading = false;
        state.inspectionTypeList = action.payload;
    })
        .addCase(inspections_actions_1.fetchInspectionOverviewRejected, function (state) {
        state.isLoading = false;
    })
        .addCase(inspections_actions_1.fetchInspectionStandardCodes, function (state) {
        state.isLoading = true;
    })
        .addCase(inspections_actions_1.fetchInspectionStandardCodesResolved, function (state, action) {
        var _a = action.payload, standard = _a.standard, codes = _a.codes;
        state.codesByStandard[standard] = codes;
        state.isLoading = false;
    })
        .addCase(inspections_actions_1.fetchInspectionStandardCodesRejected, function (state) {
        state.isLoading = false;
    });
});
exports["default"] = inspectionTypesReducer;


/***/ }),

/***/ "./reducers/rehab.reducer.ts":
/*!***********************************!*\
  !*** ./reducers/rehab.reducer.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initialState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var rehab_actions_1 = __webpack_require__(/*! @Actions/rehab.actions */ "./actions/rehab.actions.ts");
exports.initialState = {
    isLoading: false,
    eventTypes: [],
    taskTypes: [],
    conditionScores: [],
};
var rehabReducer = (0, toolkit_1.createReducer)(exports.initialState, function (builder) {
    builder
        .addCase(rehab_actions_1.fetchFieldMetadataAction, function (state) {
        state.isLoading = true;
    })
        .addCase(rehab_actions_1.fetchFieldMetadataResolved, function (state, action) {
        state.isLoading = false;
        if (action.payload.type === 'events') {
            state.eventTypes = action.payload.data;
        }
        else if (action.payload.type === 'tasks') {
            state.taskTypes = action.payload.data;
        }
        else if (action.payload.type === 'condition') {
            state.conditionScores = action.payload.data;
        }
    })
        .addCase(rehab_actions_1.fetchFieldMetadataRejected, function (state) {
        state.isLoading = false;
    });
});
exports["default"] = rehabReducer;


/***/ }),

/***/ "./reducers/util.reducer.ts":
/*!**********************************!*\
  !*** ./reducers/util.reducer.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reducer = exports.initState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var util_actions_1 = __webpack_require__(/*! @Actions/util.actions */ "./actions/util.actions.ts");
exports.initState = {
    assetBackLabel: 'Back',
};
exports.reducer = (_a = {},
    _a[util_actions_1.setAssetBackLabel.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetBackLabel: action.payload })); },
    _a);
exports["default"] = (0, toolkit_1.createReducer)(exports.initState, exports.reducer);


/***/ }),

/***/ "./store/config.store.ts":
/*!*******************************!*\
  !*** ./store/config.store.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.routeNamespace = exports.moduleNamespace = void 0;
exports.moduleNamespace = 'venus';
exports.routeNamespace = '/deterioration';


/***/ }),

/***/ "./utils/actions.ts":
/*!**************************!*\
  !*** ./utils/actions.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addRouteNamespace = exports.addNamespace = void 0;
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var addNamespace = function (action) { return config_store_1.moduleNamespace + '/' + action; };
exports.addNamespace = addNamespace;
var addRouteNamespace = function (route) { return config_store_1.routeNamespace + '/' + route; };
exports.addRouteNamespace = addRouteNamespace;


/***/ }),

/***/ "@innovyze/lib-am-common/Reducers":
/*!***************************************************!*\
  !*** external "@innovyze/lib-am-common/Reducers" ***!
  \***************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Reducers__;

/***/ }),

/***/ "@reduxjs/toolkit":
/*!**********************************************************************************************************************************!*\
  !*** external {"commonjs":"@reduxjs/toolkit","commonjs2":"@reduxjs/toolkit","amd":"@Reduxjs/Toolkit","root":"@Reduxjs/Toolkit"} ***!
  \**********************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__;

/***/ }),

/***/ "redux":
/*!**************************************************************************************!*\
  !*** external {"commonjs":"redux","commonjs2":"redux","amd":"Redux","root":"Redux"} ***!
  \**************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_redux__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./reducers/index.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=Reducers.js.map